import React from 'react'
import ReactPlayer from 'react-player'
import video from "../Manual/IndicadoresAyB.mp4"

function IndicadorMortalidadManual() {
  return (
    <div>
        <center>
<ReactPlayer
url={require("../Manual/GrupoMortalidad.mp4")}
width="50%"
height="50%"
controls
playing
muted
loop


/>
</center>
    </div>
  )
}

export default IndicadorMortalidadManual